import type { init } from "@sentry/nextjs";

const identifyingHeaders = {
  deny: ["forwarded", "-ip", "remote-", "via", "-user"],
};

/**
 * Leaves out user info, cookies, HTTP bodies, database queries, queue
 * payloads, GraphQL operations and GenAI content, and filters
 * identifying headers and query parameters.
 */
export const sentryDataCollection = {
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: {
      request: identifyingHeaders,
      response: identifyingHeaders,
    },
    httpBodies: [],
    urlQueryParams: identifyingHeaders,
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
    queues: false,
    graphQL: { document: false, variables: false },
  },
} satisfies Pick<Parameters<typeof init>[0], "dataCollection">;
